import { AgeGroup, Category, ClassLevel, ClassRule, CompetitionLevel, Dance, Discipline, Division, FederationClass, FederationUser, User } from '@vote4dance/judging-schema';
import { Federation } from '@vote4dance/judging-schema';
import { DisciplineId, DivisionId, FederationId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";
import { OrganizationItem } from './organizations';

export type FederationItem = Federation
& Pick<FederationUser, 'federation_permissions'>
& {
    ranking_count: number
};

export const FederationSource = new StreamSource<FederationItem[]>("/federations");

export const UserFederationSource = new StreamSource<FederationItem[]>("/user-federations");

export type DisciplineItem = Discipline
& {
    class_children: number
}

export type ClassRuleItem = ClassRule
& {
    [key: string]: string | number | null | undefined;
}

export type FederationUserItem = FederationUser
& Pick<User, 'user_email' | 'user_firstname' | 'user_lastname'>

type FederationUserItemCompanion = {
    getFullName(user: FederationUserItem): string
}

export const FederationUserItem: FederationUserItemCompanion = {
    getFullName(user: FederationUserItem): string {
        return user.user_firstname + ' ' + user.user_lastname;
    }
}

export function FederationUserSource(federation_id: FederationId) {
    return new StreamSource<FederationUserItem[]>(`/federations/${federation_id}/users`);
}

export function FederationOrganizationSource(federation_id: FederationId) {
    return new StreamSource<OrganizationItem[]>(`/federations/${federation_id}/organizations`);
}

export function DivisionSource(federation_id: FederationId) {
    return new StreamSource<Division[]>(`/federations/${federation_id}/divisions`);
}

export function AgeGroupSource(federation_id: FederationId, division_id: DivisionId) {
    return new StreamSource<AgeGroup[]>(`/federations/${federation_id}/divisions/${division_id}/agegroups`);
}

export function DisciplineSource(federation_id: FederationId, division_id: DivisionId) {
    return new StreamSource<DisciplineItem[]>(`/federations/${federation_id}/divisions/${division_id}/disciplines`);
}

export function CategorySource(federation_id: FederationId, division_id: DivisionId) {
    return new StreamSource<Category[]>(`/federations/${federation_id}/divisions/${division_id}/categories`);
}

export function CompetitionLevelSource(federation_id: FederationId, division_id: DivisionId) {
    return new StreamSource<CompetitionLevel[]>(`/federations/${federation_id}/divisions/${division_id}/competitionlevels`);
}

export function ClassLevelSource(federation_id: FederationId, division_id: DivisionId) {
    return new StreamSource<ClassLevel[]>(`/federations/${federation_id}/divisions/${division_id}/classlevels`);
}

export function FederationClassSource(federation_id: FederationId) {
    return new StreamSource<FederationClass[]>(`/federations/${federation_id}/classes`);
}

export function DisciplineClassSource(federation_id: FederationId, division_id: DivisionId, discipline_id: DisciplineId) {
    return new StreamSource<FederationClass[]>(`/federations/${federation_id}/divisions/${division_id}/disciplines/${discipline_id}/classes`);
}

export function DivisionClassSource(federation_id: FederationId, division_id: DivisionId) {
    return new StreamSource<FederationClass[]>(`/federations/${federation_id}/divisions/${division_id}/classes`);
}

export function ClassRuleSource(federation_id: FederationId, division_id: DivisionId, discipline_id: DisciplineId) {
    return new StreamSource<ClassRuleItem[]>(`/federations/${federation_id}/divisions/${division_id}/disciplines/${discipline_id}/rules`);
}

export function DanceSource(federation_id: FederationId, division_id: DivisionId, discipline_id: DisciplineId) {
    return new StreamSource<Dance[]>(`/federations/${federation_id}/divisions/${division_id}/disciplines/${discipline_id}/dances`);
}
